// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PostsPage_SearchBar__djWkl input {
    border-radius: 20px;
    color: #242a3d;
    padding-left: 40px;
    margin-bottom: 16px;
}

.PostsPage_SubTitle__J-mvp {
  background-color: #e8f0f1;
  font-weight: 700;
}

.PostsPage_BreakTitle__Xan3U {
  border-top: 10px solid #e8f0f1;
}

.PostsPage_BreakTitle__Xan3U {
  border-top: 10px solid #e8f0f1;
}

.PostsPage_Blueback__NiqPL {
  font-weight: 700;
  color: rgb(15, 163, 163);
}

.PostsPage_Info__fRi6w {
  color: #000;
}

.PostsPage_Top__zNuEM {
  background-color: #1ea7ae;
  color: #fff;
  border: 1px solid #fff
}

.PostsPage_Top__zNuEM:hover {
  background-color: #22b9c1;
  color: #fff;
}

.PostsPage_Top__zNuEM i:hover {
  color: #fff;
}

.PostsPage_Title__aV2x5 {
  background-color: #fff;
}

.PostsPage_InputBar__F0npu {
  background: #ffffff;
  border: 1px solid #e0e3eb;
  box-sizing: border-box;
  border-radius: 2px;
  color: #747686;
  padding: 0px 10px;
  height: 30px !important;
  /* text-align: center; */
}

@media screen and (max-width: 600px) {
  .PostsPage_InputBar__F0npu {
    height: 20px !important;
    font-size: .75rem !important;
}

  .PostsPage_Titlelist__965pe {
    font-size: .75rem ;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/PostsPage.module.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX;AACF;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE;IACE,uBAAuB;IACvB,4BAA4B;AAChC;;EAEE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".SearchBar input {\n    border-radius: 20px;\n    color: #242a3d;\n    padding-left: 40px;\n    margin-bottom: 16px;\n}\n\n.SubTitle {\n  background-color: #e8f0f1;\n  font-weight: 700;\n}\n\n.BreakTitle {\n  border-top: 10px solid #e8f0f1;\n}\n\n.BreakTitle {\n  border-top: 10px solid #e8f0f1;\n}\n\n.Blueback {\n  font-weight: 700;\n  color: rgb(15, 163, 163);\n}\n\n.Info {\n  color: #000;\n}\n\n.Top {\n  background-color: #1ea7ae;\n  color: #fff;\n  border: 1px solid #fff\n}\n\n.Top:hover {\n  background-color: #22b9c1;\n  color: #fff;\n}\n\n.Top i:hover {\n  color: #fff;\n}\n\n.Title {\n  background-color: #fff;\n}\n\n.InputBar {\n  background: #ffffff;\n  border: 1px solid #e0e3eb;\n  box-sizing: border-box;\n  border-radius: 2px;\n  color: #747686;\n  padding: 0px 10px;\n  height: 30px !important;\n  /* text-align: center; */\n}\n\n@media screen and (max-width: 600px) {\n  .InputBar {\n    height: 20px !important;\n    font-size: .75rem !important;\n}\n\n  .Titlelist {\n    font-size: .75rem ;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"SearchBar": `PostsPage_SearchBar__djWkl`,
	"SubTitle": `PostsPage_SubTitle__J-mvp`,
	"BreakTitle": `PostsPage_BreakTitle__Xan3U`,
	"Blueback": `PostsPage_Blueback__NiqPL`,
	"Info": `PostsPage_Info__fRi6w`,
	"Top": `PostsPage_Top__zNuEM`,
	"Title": `PostsPage_Title__aV2x5`,
	"InputBar": `PostsPage_InputBar__F0npu`,
	"Titlelist": `PostsPage_Titlelist__965pe`
};
export default ___CSS_LOADER_EXPORT___;
